import {injectable} from "inversify";
import settings, {SettingType} from '@/modules/settings/resources/settings';
import {Setting} from "@/modules/settings/entity";

@injectable()
export default class SettingRepository {
  public async set(name: 'game_id', value: string): Promise<void>;
  public async set(name: 'auto_save', value: boolean): Promise<void>;
  public async set(name: 'stop_evaluation_on_start_of_the_week', value: boolean): Promise<void>;
  public async set(name: 'match_evaluation_fast_speed', value: boolean): Promise<void>;
  public async set(name: 'match_evaluation_show_incidents', value: boolean): Promise<void>;
  public async set(name: SettingType, value: boolean | string | number | null | undefined) {
    let setting = await Setting.findOne({
      where: {
        name,
      }
    });

    if (!setting) {
      setting = new Setting();
      setting.name = name;
    }

    setting.value = value;
    await setting.save();
  }

  public async get(name: 'game_id'): Promise<string>;
  public async get(name: 'auto_save'): Promise<boolean>;
  public async get(name: 'stop_evaluation_on_start_of_the_week'): Promise<boolean>;
  public async get(name: 'match_evaluation_fast_speed'): Promise<boolean>;
  public async get(name: 'match_evaluation_show_incidents'): Promise<boolean>;
  public async get(name: SettingType): Promise<boolean | string | number | null | undefined> {
    const setting = await Setting.findOne({
      where: {
        name,
      }
    });

    if (setting) {
      return setting.value;
    }

    if (!Object.keys(settings).includes(name)) {
      throw `There is no setting for '${name}'`;
    }

    return settings[name];
  }
}
